export const redirectConstants = {
  REDIRECT: '[Ui] Nav',
  REDIRECT_DONE: '[Ui] Nav Success'
}
